import React, { useState } from 'react';
import './App.css';
import Login from './components/Login';
import Welcome from './pages/Welcome';
import OptionDataDisplay from './components/OptionDataDisplay';
import ExcelUploader from './components/ExcelUploader';
import InstrumentDownload from './components/InstrumentDownload';
import StrikeDataManager from './components/StrikeDataManager';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, NavLink, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import TradeHistory from './components/TradeHistory';
import LogViewer from './components/LogViewer';
import { Navbar, Nav, Container, Button, Modal } from 'react-bootstrap';

const PrivateRoute = ({ children }) => {
    const userInfo = sessionStorage.getItem('userInfo');
    return userInfo ? children : <Navigate to="/login" />;
};

const Layout = ({ children, onLogout }) => {
    const location = useLocation();
    const showNavbar = location.pathname !== '/login';
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const handleShowLogoutModal = () => setShowLogoutModal(true);
    const handleCloseLogoutModal = () => setShowLogoutModal(false);
    const handleConfirmLogout = () => {
        setShowLogoutModal(false);
        onLogout();
    };

    return (
        <>
            {showNavbar && (
                <Navbar bg="white" expand="md" className="mb-0">
                    <Container fluid>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="stytp flex-column flex-md-row w-100 justify-content-md-evenly align-items-md-center">
                                <NavLink
                                    to="/"
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    Dashboard
                                </NavLink>
                                <NavLink
                                    to="/manage-strikes"
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    Strike Data Manager
                                </NavLink>
                                <NavLink
                                    to="/excel-to-json"
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    Converter
                                </NavLink>
                                <NavLink
                                    to="/view-json"
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    View JSON
                                </NavLink>
                                <NavLink
                                    to="/instrument-data"
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    Instrument Data
                                </NavLink>
                                <NavLink
                                    to="/trade-history"
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    Trade History
                                </NavLink>
                                <NavLink
                                    to="/log-viewer"
                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                >
                                    Log Viewer
                                </NavLink>
                                <Button
                                    onClick={handleShowLogoutModal}
                                    className="btn btn-danger text-light text-decoration-none mt-2 mt-md-0 ms-md-2"
                                >
                                    Logout
                                </Button>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            )}
            <Modal show={showLogoutModal} onHide={handleCloseLogoutModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to log out?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleConfirmLogout}>
                        Confirm
                    </Button>
                    <Button variant="secondary" onClick={handleCloseLogoutModal}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            {children}
        </>
    );
};

const AppContent = () => {
    const [userProfile, setUserProfile] = useState(JSON.parse(sessionStorage.getItem('userInfo')) || null);
    const navigate = useNavigate();

    const handleLogout = () => {
        sessionStorage.removeItem('userInfo');
        setUserProfile(null);
        navigate('/login');
    };

    return (
        <Layout onLogout={handleLogout}>
            <Routes>
                <Route
                    path="/login"
                    element={
                        sessionStorage.getItem('userInfo') ? (
                            <Navigate to="/" />
                        ) : (
                            <Login onSuccess={(userInfo) => setUserProfile(userInfo)} />
                        )
                    }
                />
                <Route
                    path="/"
                    element={
                        <PrivateRoute>
                            <Welcome user={userProfile} />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/view-json"
                    element={
                        <PrivateRoute>
                            <OptionDataDisplay />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/excel-to-json"
                    element={
                        <PrivateRoute>
                            <ExcelUploader />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/instrument-data"
                    element={
                        <PrivateRoute>
                            <InstrumentDownload />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/manage-strikes"
                    element={
                        <PrivateRoute>
                            <StrikeDataManager />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/trade-history"
                    element={
                        <PrivateRoute>
                            <TradeHistory />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/log-viewer"
                    element={
                        <PrivateRoute>
                            <LogViewer />
                        </PrivateRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Layout>
    );
};

const App = () => {
    return (
        <div className="ab-api-wrap">
            <div className="ab-api-content">
                <Router>
                    <AppContent />
                </Router>
            </div>
        </div>
    );
};

export default App;